import { useApi } from "@backstage/core";
import { useCallback, useEffect } from "react";
import { useAsyncFn } from "react-use";
import { githubApiRef } from "../api/GithubApi";
import { handleError } from "@internal/plugin-utilities";

export const useUserCommits = ({ handle }: { handle: string }) => {
  const api = useApi(githubApiRef);

  const getUserCommits = useCallback(async () => {
    try {
      return await api.getCommitsByUser(handle);
    } catch (err: any) {
      return handleError(err);
    }
  }, [api, handle]);

  const [state, fetchUserCommits] = useAsyncFn(() => getUserCommits(), []);

  useEffect(() => {
    fetchUserCommits();
  }, [fetchUserCommits]);

  return {
    loading: state.loading,
    error: state.error,
    results: state?.value?.data,
    fetchUserCommits,
  };
};
